import React from "react";

import Message from "./Message";
import FileMessage from "./FileMessage";
import VoiceMessage from "./VoiceMessage";
import VideoMessage from "./VideoMessage";
import PrescriptionMessage from "./PrescriptionMessage";

import "./ChatList.css";
import PictureMessage from "./PictureMessage";
import SystemMessages from "./SystemMessages";




export default ({ chats, UserId, reply, deleteMessage, hasReply }) => {

  function getFileExtension(filename) {
    if (filename != null) {
      return filename.split(".").pop();
    } else {
      return;
    }
  }




  
      

  return (
    <div className="chat_lists"
    // style={{ border: '3px solid gray' }}
    >


      
      { 
      
      chats.map((chat) => {

        if(!chat){
          return ;
        }else{
        }
        

        if (chat.type === "file_message" && chat.reply_to) {
          
          let found = chats && chats.find((item) => item.id == chat.reply_to);
          
          return (
            <>
              <div
                className={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? "chat_item me"
                    : "chat_item"
                }
                style={styles.replyWrap}
              >
                <div>
                  <span>پاسخ به :</span>
                  {found && found.file}
                </div>
                <FileMessage
                  chat={chat}
                  UserId={UserId}
                  key={chat.key}
                  reply={() => reply(chat)}
                  deleteMessage={() => deleteMessage(chat)}
                />
              </div>
              <div className="clearfix" />
            </>
          );
        }
        else if (chat.type === "file_message") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <FileMessage
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
              />
            </div>
          );
        }
        else if (chat.type === "dossierPhoto") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <PictureMessage
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
              />
            </div>
          );
        }
        else if (chat.type === "dossierFile") {

          let ext = getFileExtension(chat.file);
          if (ext == "jpg" || ext == "jpeg" || ext == "png") {
            return (
              <div
                className={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? "chat_item me"
                    : "chat_item"
                }
              >
                <PictureMessage
                  chat={chat}
                  UserId={UserId}
                  key={chat.key}
                  reply={() => reply(chat)}
                  deleteMessage={() => deleteMessage(chat)}
                />
              </div>
            );
          } else {
            return (
              <div
                className={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? "chat_item me"
                    : "chat_item"
                }
              >
                <FileMessage
                  chat={chat}
                  UserId={UserId}
                  key={chat.key}
                  reply={() => reply(chat)}
                  deleteMessage={() => deleteMessage(chat)}
                />
              </div>
            );
          }
        }
        else if (chat.type_message && chat.type_message === "dossiers") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              {/* <p style={{ textAlign: "center" }}>سند پزشکی</p> */}
              <FileMessage
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
              />
            </div>
          );
        }
        else if (chat.type === "prescriptionPhoto") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <PictureMessage
                prescriptionFileStyle={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      border: "dotted",
                      borderColor: "#fff",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#7747c0",
                      color: "#fff",
                    }
                    : {
                      border: "dotted",
                      borderColor: "#7747c0",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#fff",
                      color: "#000000",
                    }
                }
                prescriptionFileStyle2={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      backgroundColor: "#7747c0",
                      color: "#fff",
                    }
                    : {
                      backgroundColor: "#fff",
                      color: "#000000",
                    }
                }
                doc="  دستور پزشکی"
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
              />
            </div>
          );
        }
        else if (chat.type === "prescriptionFile" && chat.file != null) {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <FileMessage
                prescriptionFileStyle={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      border: "dotted",
                      borderColor: "#fff",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#7747c0",
                    }
                    : {
                      border: "dotted",
                      borderColor: "#7747c0",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#fff",
                    }
                }
                prescriptionFileStyle2={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      backgroundColor: "#7747c0",
                    }
                    : {
                      backgroundColor: "#fff",
                    }
                }
                doc=" : دستور پزشکی"
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
              />
            </div>
          );
        }
        else if (chat.type === "prescriptionFile" && chat.file == null) {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <PrescriptionMessage
                prescriptionFileStyle={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      border: "dotted",
                      borderColor: "#fff",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#7747c0",
                    }
                    : {
                      border: "dotted",
                      borderColor: "#7747c0",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#fff",
                    }
                }
                prescriptionFileStyle2={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      backgroundColor: "#7747c0",
                    }
                    : {
                      backgroundColor: "#fff",
                    }
                }
                doc=" دستور پزشکی"
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
              />
            </div>
          );
        }
        else if (chat.type === "voice_message" && chat.reply_to) {
          let found = chats && chats.find((item) => item.id == chat.reply_to);

          return (
            <>
              <div
                className={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? "chat_item me"
                    : "chat_item"
                }
                style={styles.replyWrap}
              >
                <div>
                  <span>پاسخ به :</span>
                  {found && found.file}
                </div>
                <VoiceMessage
                  chat={chat}
                  UserId={UserId}
                  key={chat.key}
                  reply={() => reply(chat)}
                  deleteMessage={() => deleteMessage(chat)}
                />
              </div>
            </>
          );
        }
        else if (chat.type === "voice_message") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <VoiceMessage
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
              />
            </div>
          );
        }
        else if (chat.type === "prescriptionVoice") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <VoiceMessage
                prescriptionVoiceStyle={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      border: "dotted",
                      borderColor: "#fff",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#7747c0",
                    }
                    : {
                      border: "dotted",
                      borderColor: "#7747c0",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#fff",
                    }
                }
                prescriptionVoiceStyle2={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      backgroundColor: "#7747c0",
                    }
                    : {
                      backgroundColor: "#fff",
                    }
                }
                doc="دستور پزشکی"
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
              />
            </div>
          );
        }
        else if (chat.type === "dossierVoice" && chat.reply_to) {
          let found = chats && chats.find((item) => item.id == chat.reply_to);

          return (
            <>
              <div
                className={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? "chat_item me"
                    : "chat_item"
                }
                style={styles.replyWrap}
              >
                <div>
                  <span>پاسخ به :</span>
                  {found && found.file}
                </div>
                <VoiceMessage
                  chat={chat}
                  UserId={UserId}
                  key={chat.key}
                  reply={() => reply(chat)}
                  deleteMessage={() => deleteMessage(chat)}
                />
              </div>
            </>
          );
        }
        else if (chat.type === "dossierVoice") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <VoiceMessage
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
              />
            </div>
          );
        }
        else if (chat.type === "text" && chat.reply_to) {
          let found = chats && chats.find((item) => item.id == chat.reply_to);
          return (
            <>
              <div
                className={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? "chat_item me"
                    : "chat_item"
                }
                style={styles.replyWrap}
              >
                <div>
                  <span>پاسخ به :</span>
                  {found && found.message}
                </div>

                <Message
                  chat={chat}
                  UserId={UserId}
                  key={chat.key}
                  reply={() => reply(chat)}
                  deleteMessage={() => deleteMessage(chat)}
                  hasReply={hasReply}
                />
              </div>
              <div className="clearfix" />
            </>
          );
        }
        else if (chat.type === "text") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <Message
                chat={chat}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
                hasReply={hasReply}
              />
            </div>
          );
        }
        else if (chat.type === "video_message" && chat.reply_to) {
          let found = chats && chats.find((item) => item.id == chat.reply_to);

          return (
            <>
              <div
                className={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? "chat_item me"
                    : "chat_item"
                }
                style={styles.replyWrap}
              >
                <div>
                  <span>پاسخ به :</span>
                  {found && found.file}
                </div>
                <VideoMessage
                  src={chat.file}
                  UserId={UserId}
                  key={chat.key}
                  reply={() => reply(chat)}
                  deleteMessage={() => deleteMessage(chat)}
                  chat={chat}
                />
              </div>
              <div className="clearfix" />
            </>
          );
        }
        else if (chat.type === "video_message") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <VideoMessage
                src={chat.file}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
                chat={chat}
              />
            </div>
          );
        }
        else if (chat.type === "prescriptionVideoMessage") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <VideoMessage
                prescriptionVideoStyle={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      border: "dotted",
                      borderColor: "#fff",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#7747c0",
                    }
                    : {
                      border: "dotted",
                      borderColor: "#7747c0",
                      borderRadius: 18,
                      padding: 5,
                      backgroundColor: "#fff",
                    }
                }
                prescriptionVideoStyle2={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? {
                      backgroundColor: "#7747c0",
                    }
                    : {
                      backgroundColor: "#fff",
                    }
                }
                doc="دستور پزشکی"
                src={chat.file}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
                chat={chat}
              />
            </div>
          );
        }
        else if (chat.type === "dossierVideoMessage" && chat.reply_to) {
          let found = chats && chats.find((item) => item.id == chat.reply_to);

          return (
            <>
              <div
                className={
                  parseInt(UserId) === parseInt(chat.user_id)
                    ? "chat_item me"
                    : "chat_item"
                }
                style={styles.replyWrap}
              >
                <div>
                  <span>پاسخ به :</span>
                  {found && found.file}
                </div>
                <VideoMessage
                  src={chat.file}
                  UserId={UserId}
                  key={chat.key}
                  reply={() => reply(chat)}
                  deleteMessage={() => deleteMessage(chat)}
                  chat={chat}
                />
              </div>
              <div className="clearfix" />
            </>
          );
        }
        else if (chat.type === "dossierVideoMessage") {
          return (
            <div
              className={
                parseInt(UserId) === parseInt(chat.user_id)
                  ? "chat_item me"
                  : "chat_item"
              }
            >
              <VideoMessage
                src={chat.file}
                UserId={UserId}
                key={chat.key}
                reply={() => reply(chat)}
                deleteMessage={() => deleteMessage(chat)}
                chat={chat}
              />
            </div>
          );
          // dossierVideoMessage
        }
        else if (chat.type === "systemMessages") {
          return (
            <div
              style={{
                background: "#fff",
                borderRadius: 13,
                padding: "10px 13px",
                marginBottom: 10,
                minWidth: 250,
                fontSize: "0.8em",
                display: "block",
                backgroundColor: "#fbf8ff",
                color: "#7144b7",
                lineHeight: "2.5em",
                border: "2px solid #7144b7",
              }}
            >
              <SystemMessages chat={chat} />
            </div>
          );
        }
        else {
          return null;
        }
      })}
      {/* enable this two lines for testing */}
      {/* <FileMessage chat={chats[1]} UserId={UserId} key={chats[0].key} />
		<VoiceMessage chat={chats[0]} UserId={UserId} key={chats[0].key} /> */}
      <div id="chat_list_end" />
    </div>
  )
}

const styles = {
  replyWrap: {
    display: "inlineBlock",
    background: "#fcf9de",
    padding: 10,
    border: "1px solid #fcf9de",
    borderRadius: 4,
    boxShadow: "1px 3px 1px #faf4c5",
    margin: 10,
  },
};
